import React, {useState, useEffect, useCallback} from 'react';
import {Input, Button, Image, message, Space} from 'antd'
import {useParams, useNavigate} from 'react-router-dom'
import {YunyingUploader} from '../../components/Uploader'
import Api from '../../api'
import {emptyValidate} from '../../util/validate'


export default function () {
    const navigate = useNavigate();
    const params = useParams();
    const [picUrl, setPicUrl] = useState()
    const [title, setTitle] = useState()

    useEffect(() => {
        if (params.id) {
            Api.getPictureLibList()
            .then(resp=>{
                const filterlist = resp.list.filter(item => item.id==params.id);
                setTitle(filterlist[0].title)
                setPicUrl(filterlist[0].picUrl)
            })
        } else {
            setTitle()
            setPicUrl()
        }
    }, [params.id])


    const save = useCallback(() => {
        let data = {
            picUrl,
            title,
        }

        let validateResult = emptyValidate(title, '请填写学校名称')
            || emptyValidate(picUrl, '请上传学校Logo')

        if (validateResult) {
            return;
        }


        if (params.id) {
            data.id = params.id
        }

        Api.editPictureLib(data).then(resp => {
            if (resp.resultCode === 1) {
                message.success(resp.resultMessage)
                if (params.id) {
                    navigate(-1)
                } else {
                    navigate('/school/list')
                }
            }
        })
    })

    const cancel = useCallback((url) => {
        if (params.id) {
            navigate(-1)
        } else {
            navigate('/school/list')
        }
    })

    const onResult = useCallback((res) => {
        setPicUrl(res.picUrl)
    })


    return <div className="white-bg pdv40 pdh32 mgv12" style={{minWidth:800, maxWidth: 1200}}>
        <div className="flexbox">
            <div className="pd12" style={{width: '400px'}}>
                <div className="required bold">学校名称</div>
                <div className="mgb20 pdv12">
                    <Input
                        value={title}
                        onChange={e => setTitle(e.target.value)}
                        maxLength={40}
                        placeholder="请输入讲师昵称"/>
                </div>

                <div className="required bold">学校Logo：</div>
                <div className="pdv12">
                   <YunyingUploader type="00" onResult={onResult}>
                        {picUrl && <Image src={picUrl} preview={false} style={{width: 100, height: 100}}/>}
                    </YunyingUploader>
                    <div>支持jpg、png、jpeg格式</div>
                </div>
            </div>
        </div>
        <div className="text-right mgt30">
            <Space>
                <Button onClick={cancel}>取消</Button>
                <Button type="primary" onClick={save}>保存</Button>
            </Space>
        </div>
    </div>
}
